/* 2026 WilderdijkDynamics. Version 4.71.
   Keep Empire's ORIGINAL Liquid hierarchy: productitem > productitem__container
   > productitem--info + productitem--actions. In 4.70 actions were moved OUT of
   the container, bypassing its normal flex flow and leaving the desktop button
   over stock/delivery content. Only keep the grid/list class synchronization.
   Never clone/replace action buttons or handlers; preserve Shopify integration. */
(function () {
  'use strict';
  function sync(root) {
    var listView = root.classList.contains('productgrid-listview');
    root.querySelectorAll('[data-wd-r19-card]').forEach(function (tile) {
      tile.classList.toggle('wd-r19-card', !listView);
      var product = tile.querySelector('[data-product-item-content]');
      var container = product && product.querySelector('.productitem__container');
      var info = container && container.querySelector('.productitem--info');
      var actions = product && product.querySelector('[data-product-actions]');
      if (!product || !container || !info || !actions) return;
      // Restore the original Liquid placement if 4.70's move ran on an
      // existing DOM (e.g. when an editor section is re-rendered).
      if (actions.parentElement !== container) container.appendChild(actions);
    });
    document.dispatchEvent(new CustomEvent('wd:product-card-view-changed'));
  }
  function init() {
    document.querySelectorAll('.productgrid--outer').forEach(function (root) {
      sync(root);
      new MutationObserver(function (records) {
        if (records.some(function (record) { return record.attributeName === 'class'; })) sync(root);
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
    });
    var wasDesktop = window.matchMedia('(min-width: 1024px)').matches;
    window.addEventListener('resize', function () {
      var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      if (isDesktop !== wasDesktop) {
        wasDesktop = isDesktop;
        document.querySelectorAll('.productgrid--outer').forEach(sync);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
